export function exportCrop(
  srcCanvas,
  pos,
  crop,
  pixelRatio = 1,
  restrictImageRatio = 10
) {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");
  const kinsiImg = document.getElementById("kinsiImg");
  canvas.width = srcCanvas.width / pixelRatio;
  canvas.height = srcCanvas.height / pixelRatio;
  context.drawImage(
    kinsiImg,
    pos.x / restrictImageRatio,
    pos.y / restrictImageRatio,
    crop / restrictImageRatio,
    crop / restrictImageRatio,
    0,
    0,
    crop,
    crop
  );

  // source-inだと禁止エリアの外に描きこみ
  context.globalCompositeOperation = "source-out";

  context.drawImage(
    srcCanvas,
    0,
    0,
    canvas.width,
    canvas.height
  );
  return canvas.toDataURL("image/png");
}
